import MainRoutes from "routes/mainRouter";
import "bootstrap-daterangepicker/daterangepicker.css";

const App = () => {
  return <MainRoutes />;
};

export default App;
